import type { ProductTileFragment } from '@/lib/types/datocms/graphql/generated'
import { TextWithHighlight } from '../TextWithHighlight'
import Eyebrow from '../ui/Eyebrow'
import ProductTilePreviewCard from '../ProductTilePreviewCard'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'

export default function ProductTileSection({
	title,
	tag,
	productCard,
}: Readonly<ProductTileFragment>) {
	return (
		<section className="product-tile-section @container">
			<div className="max-w-screen-2xl common-x-padding py-16 @5xl:py-24 mx-auto">
				{tag && <Eyebrow>{tag}</Eyebrow>}
				{title && !isStructuredTextEmpty(title.text) && (
					<div className="heading-size-3 mt-10">
						<TextWithHighlight text={title} />
					</div>
				)}
				<div className="grid grid-cols-1 @5xl:grid-cols-2 gap-5 mt-8 @5xl:mt-20">
					{productCard?.product.map((item, idx) => (
						<ProductTilePreviewCard key={item.id as string} productCard={item} idx={idx} />
					))}
				</div>
			</div>
		</section>
	)
}
